import React, { type ReactNode, type FC } from 'react'

interface IProps {
  answers: IAnswer[]
  answersLeft: number
  handleSaveAnswer: (answer: IAnswer) => void
  getClassName: (answer: IAnswer, classes: IClasses) => string
  children: ReactNode
}
interface IClasses {
  base: string
  hover: string
  isWaiting: string
  isCorrect: string
  isWrong: string
}

const LongAnswers: FC<IProps> = ({ answers, answersLeft, handleSaveAnswer, getClassName, children }) => {
  return (
    <div className={'flex flex-col gap-4 pr-4 lg:gap-6 lg:overflow-auto'}>
      {answers.map((answer, index) => (
        <button
          key={answer.id}
          className={getClassName(answer, {
            base: `text-base border border-duskBlack flex justify-center items-center p-3 transition-colors lg:text-xl`,
            hover: ' hover:text-sunriseGoldDarker hover:border-sunriseGoldDarker',
            isWaiting: 'border-sunriseGoldDarker bg-sunriseGold text-duskBlack',
            isCorrect: 'border-forestGreen bg-forestGreen text-pureWhite',
            isWrong: 'border-sunsetRed bg-sunsetRed text-pureWhite',
          })}
          disabled={answersLeft === 0}
          onClick={() => {
            handleSaveAnswer(answer)
          }}
        >
          {answer.label}
        </button>
      ))}
      {children}
    </div>
  )
}
export default LongAnswers
